module.exports = __webpack_public_path__ + "images/help/searchbox-e123e5555fffef965e8b019ccbea47c0.png";